import { render, staticRenderFns } from "./AddIp.vue?vue&type=template&id=53b0eff0&"
import script from "./AddIp.vue?vue&type=script&lang=js&"
export * from "./AddIp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports